export default "__VITE_ASSET__CPyqYc87__"